import React from "react"
import "./ProgressBar.css"
const ProgressBar = ({
  value,
  onChange,
  min = 0,
  max = 100,
  title,
  subText,
  containerClass = "",
}) => {


  return (
    <progress value="3333" max="10000">33%</progress>
  )
}

export default ProgressBar
